import { Grid, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';

const Conversation = () => {
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const containerStyle = {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		maxWidth: '1200px',
		margin: '0 auto',
		backgroundColor: '#f9f9f9',
		marginTop: 50,
	};

	const benefitsStyle = {
		flex: 1,
		paddingRight: '20px',
	};

	const headingStyle = {
		fontSize: '36px',
		color: '#000',
		marginBottom: '20px',
		fontWeight: 'bold',
		textAlign: 'center',
	};

	const listStyle = {
		listStyle: 'none',
		padding: '0',
		lineHeight: '1.8',
	};

	const listItemStyle = {
		marginBottom: '10px',
		fontSize: '16px',
		color: '#333',
	};

	const awardsStyle = {
		display: 'flex',
		gap: '10px',
		marginTop: '20px',
	};

	const awardImageStyle = {
		width: '80px',
		height: 'auto',
		borderRadius: '5px',
	};

	const formContainerStyle = {
		flex: 1,
		backgroundColor: '#fff',
		padding: '30px',
		borderRadius: '10px',
		boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
	};

	const inputStyle = {
		marginBottom: '15px',
		padding: '10px',
		border: '1px solid #ccc',
		borderRadius: '5px',
		fontSize: '16px',
		width: '100%',
	};

	const textareaStyle = {
		...inputStyle,
		resize: 'none',
		height: '100px',
	};

	const noteStyle = {
		fontSize: '14px',
		color: '#777',
		marginBottom: '20px',
	};

	const buttonStyle = {
		backgroundColor: '#e63946',
		color: '#fff',
		padding: '10px 15px',
		border: 'none',
		borderRadius: '5px',
		fontSize: '16px',
		cursor: 'pointer',
	};

	const buttonHoverStyle = {
		backgroundColor: '#d62839',
	};

	return (
		<>
			<h1 style={headingStyle}>Start A Conversation By Filling Out The Form</h1>

			<div style={containerStyle}>
				<Grid container spacing={2}>
					<Grid item xs={12} lg={6}>
						<div style={benefitsStyle}>
							<ul style={listStyle}>
								<li style={listItemStyle}>
									✔ Signed NDA to keep all project-related information
									confidential
								</li>
								<li style={listItemStyle}>
									✔ Free consultation for your project.
								</li>
								<li style={listItemStyle}>✔ Transparent pricing policy.</li>
								<li style={listItemStyle}>✔ Flexible engagement models.</li>
								<li style={listItemStyle}>
									✔ SWIFT kick start to your project.
								</li>
								<li style={listItemStyle}>
									✔ We always deliver the source code with the project.
								</li>
							</ul>
							<div style={awardsStyle}>
								<img
									style={awardImageStyle}
									src='https://via.placeholder.com/80'
									alt='Award 1'
								/>
								<img
									style={awardImageStyle}
									src='https://via.placeholder.com/80'
									alt='Award 2'
								/>
								<img
									style={awardImageStyle}
									src='https://via.placeholder.com/80'
									alt='Award 3'
								/>
							</div>
						</div>
					</Grid>
					<Grid item xs={12} lg={6}>
						<div style={formContainerStyle}>
							<form>
								<input
									type='text'
									placeholder='Full Name'
									required
									style={inputStyle}
								/>
								<input
									type='email'
									placeholder='Email'
									required
									style={inputStyle}
								/>
								<input
									type='tel'
									placeholder='Mobile Number With Country Code'
									required
									style={inputStyle}
								/>
								<textarea
									placeholder='Your Project Description'
									required
									style={textareaStyle}></textarea>
								<p style={noteStyle}>Your idea is protected with us.</p>
								<button
									type='submit'
									style={buttonStyle}
									onMouseOver={(e) =>
										(e.target.style.backgroundColor =
											buttonHoverStyle.backgroundColor)
									}
									onMouseOut={(e) =>
										(e.target.style.backgroundColor =
											buttonStyle.backgroundColor)
									}>
									Submit
								</button>
							</form>
						</div>
					</Grid>
				</Grid>
				{/* Benefits Section */}

				{/* Form Section */}
			</div>
		</>
	);
};

export default Conversation;
